import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=a63906cc&scoped=true&"
import script from "./Trip.vue?vue&type=script&lang=js&"
export * from "./Trip.vue?vue&type=script&lang=js&"
import style0 from "./Trip.vue?vue&type=style&index=0&id=a63906cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63906cc",
  null
  
)

export default component.exports